// extracted by mini-css-extract-plugin
export default {"expectfulLabel":"styles__expectfulLabel__da913"};